import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Btn, Reveal } from "@/components/Elements";
import { PROGRAMS, CALENDLY } from "@/data/content";

export default function LoanPrograms() {
  return (
    <div>
      <Seo
        title="Loan Programs | Conventional, FHA, VA, USDA, Refinance & Jumbo | Family First Mortgage USA"
        description="Explore loan programs with Joe Spellman at Family First Mortgage USA — Conventional, FHA, VA, USDA, Refinance and Jumbo loans for Florida homebuyers."
      />
      <PageHeader
        eyebrow="Loan Programs"
        line1="Find Your"
        line2="Perfect Loan"
        sub="Whether you're buying your first home, upgrading, or refinancing — we have a loan program designed for your situation."
      />

      <section className="bg-cream py-20 md:py-28" data-testid="programs-list">
        <div className="wrap">
          <div className="overflow-hidden rounded-3xl border border-line bg-white">
            {PROGRAMS.map((p, i) => (
              <Reveal
                as="article"
                key={p.name}
                delay={(i % 2) * 80}
                className={`grid gap-8 p-8 md:p-12 lg:grid-cols-[300px_1fr_auto] lg:items-center lg:gap-12 ${
                  i > 0 ? "border-t border-line" : ""
                }`}
                data-testid={`program-row-${i + 1}`}
              >
                <div className="flex items-start gap-5">
                  <span className="font-serif text-4xl font-normal italic text-goldpale">0{i + 1}</span>
                  <div>
                    <span className="block h-px w-10 bg-gold" aria-hidden="true" />
                    <h2 className="mt-4 font-serif text-2xl font-bold text-navy">{p.name}</h2>
                    <p className="mt-2 font-serif italic text-gold">{p.tagline}</p>
                  </div>
                </div>
                <div>
                  <p className="text-sm leading-relaxed text-ink sm:text-base">{p.desc}</p>
                  <ul className="mt-5 space-y-2.5">
                    {p.bullets.map((b) => (
                      <li key={b} className="flex gap-3 text-sm text-ink">
                        <span className="font-medium text-gold" aria-hidden="true">
                          –
                        </span>
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="lg:self-center">
                  <Btn variant="navy" href={CALENDLY} external testId={`program-apply-${i + 1}`}>
                    Apply Now
                  </Btn>
                </div>
              </Reveal>
            ))}
          </div>

          <p className="pt-8 text-xs leading-relaxed text-ink/70" data-testid="programs-disclaimer">
            All loans subject to credit approval. Program terms and availability may change. This is not a commitment
            to lend.
          </p>
        </div>
      </section>
    </div>
  );
}
